import { ChangeDetectionStrategy, Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef, KalSnackbarConfig, KalSnackbarService } from '@kalidea/kaligraphi';
import { Store } from '@ngxs/store';
import { UntypedFormControl } from '@angular/forms';
import { UserUpdateApplicationParametersAction } from 'src/app/_user/store/user/user.action';
import { ParametresUserAppliModelDto } from 'src/graphql/generated-types';
import { UserState } from 'src/app/_user/store/user/user.state';
import { tap } from 'rxjs/operators';
import cloneDeep from 'lodash-es/cloneDeep';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

export interface RgpdDialogData {
    isExport?: boolean;
    accepted?: boolean;
    submitButtonLabel?: string;
}

@Component({
    selector: 'app-rgpd-dialog',
    templateUrl: './rgpd-dialog.component.html',
    styleUrls: ['./rgpd-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RgpdDialogComponent extends SubscriptionManager implements OnDestroy {

    discardDialogControl = new UntypedFormControl(false);

    constructor(private dialogRef: KalDialogRef<RgpdDialogComponent>,
                private store: Store,
                private snackbarService: KalSnackbarService,
                @Inject(KAL_DIALOG_DATA) public data: RgpdDialogData) {
        super();
    }

    submit(): void {
        if (!this.data.isExport && this.discardDialogControl.value) {
            this.updateRgpdParameter();
        } else {
            this.close({isAccepted: true});
        }
    }

    close({isAccepted} = {isAccepted: false}): void {
        this.dialogRef.close(isAccepted ? {accepted: true} : null);
    }

    private updateRgpdParameter(): void {
        const applicationParameters = cloneDeep(this.store.selectSnapshot(UserState.applicationParameters));
        let rgpdParameter: ParametresUserAppliModelDto = applicationParameters.find(p => p.CodeChamp === 'RGPDCO');

        if (!rgpdParameter) {
            rgpdParameter = {CodeChamp: 'RGPDCO'};
        }

        rgpdParameter.CodeValeur = '0';

        this.watch$ = this.store.dispatch(new UserUpdateApplicationParametersAction([rgpdParameter])).pipe(
            tap(() => {
                this.snackbarService.open(new KalSnackbarConfig({title: 'Votre choix a bien été pris en compte.'}));
                this.close({isAccepted: true});
            })
        );
    }

}
